module.exports = __webpack_public_path__ + "fonts/NotoSerifJP-VariableFont_wght.3b977cd7.ttf";